import React, { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { admitMultiple } from '../../visitors/actions';
import { getPromotionRequests } from '../../visitors/functions';
import { VisitorsItem } from './VisitorsItem';
/**
 * Component used to display a list of visitors waiting for approval to join the main meeting.
 *
 * @returns {ReactNode}
 */
export default function VisitorsList() {
    const requests = useSelector(getPromotionRequests);
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const admitAll = useCallback(() => {
        dispatch(admitMultiple(requests));
    }, [dispatch, requests]);
    if (!requests.length) {
        return null;
    }
    return (React.createElement("div", { className: 'raised-hand-participants' },
        React.createElement("div", { className: 'raised-hand-header' },
            React.createElement("span", null,
                t('toolbar.accessibilityLabel.raiseHandParticipants'),
                ` ( ${requests.length} )`),
            requests.length > 1
                && React.createElement("button", { className: 'smallIcon', onClick: admitAll, type: 'button' }, t('participantsPane.actions.admitAll'))),
        React.createElement("div", { id: 'visitor-list' }, requests.map(r => (React.createElement(VisitorsItem, { key: r.from, request: r }))))));
}
